<template>
    <!-- my code -->
    <div class="wrapper-main-content">
        <!-- sidebar -->
            <div class="sidebar">
                <side-bar
                    :step="step"
                    :sidebarListLinks="sidebarListLinks"
                ></side-bar>
            </div>
        <!-- sidebar ends -->

        <!-- form -->
            <div class="main_content-form">
                <div class="manager-form-box position-relative p-4">
                    <div class="card-body">
                        <h1 class="head-title font-weight-bold text-center">Key Dates</h1>

                            <p class="issue-date text-center">
                                Issue Date - {{ componentForm.issue_date }}
                            </p>
                        <b-form @submit.prevent="componentFormSubmitted" class="mt-5">

                            <b-form-group label="Recurring" v-if="workOrder">
                            <b-form-select
                                v-model="componentForm.recurring"
                                :options="[
                                { value: 'on', text: 'On' },
                                { value: 'off', text: 'Off' },
                                ]"
                            ></b-form-select>
                            <has-error :form="form" field="recurring"></has-error>
                            </b-form-group>

                            <b-form-group
                                label="Recurring Period"
                                v-show="workOrder && componentForm.recurring == 'on'"
                            >
                            <div
                                style="
                                padding: 15px;
                                border: 0.5px solid #dadada;
                                margin-bottom: 15px;
                                position:relative
                                "
                                v-for="(recurringDate, idx) in componentForm.recursion_quote"
                                :key="'re' + idx"
                            >

                             <SvgIcons v-if="componentForm.recursion_quote.length > 1" icon="insurance-document-close" svgClass="ml-2" style="margin-top:2px;position:absolute;right:-27;"  @click.native="componentForm.recursion_quote.splice(componentForm.recursion_quote.indexOf(recurringDate), 1)"/>

                                <!-- <b-button
                                    style="float:right;position: absolute;right: -50px;top: 0px" variant="danger" type="button"
                                    v-if="componentForm.recursion_quote.length > 1"
                                    @click="componentForm.recursion_quote.splice(componentForm.recursion_quote.indexOf(recurringDate), 1)">
                                    X
                                </b-button> -->
                                <b-form-group>
                                <b-form-select
                                    v-model="recurringDate.recurring_period"
                                    :options="recurringOptions"
                                ></b-form-select>
                                <has-error
                                    :form="form"
                                    :field="`recursion_quote.${idx}.recurring_period`"
                                ></has-error>
                                </b-form-group>
                                <b-row>
                                <b-col
                                    v-if="recurringDate.recurring_period == 'specified_month'"
                                >
                                    <b-form-group>
                                    <b-form-select
                                        v-model="recurringDate.month"
                                        :options="monthOptions"
                                    ></b-form-select>
                                    <has-error
                                        :form="form"
                                        :field="`recursion_quote.${idx}.month`"
                                    ></has-error>
                                    </b-form-group>
                                </b-col>
                                <b-col v-if="recurringDate.recurring_period == 'weekly'">
                                    <b-form-group>
                                    <b-form-select
                                        v-model="recurringDate.day"
                                        :options="dayOptions"
                                    ></b-form-select>
                                    <has-error
                                        :form="form"
                                        :field="`recursion_quote.${idx}.day`"
                                    ></has-error>
                                    </b-form-group>
                                </b-col>
                                <b-col
                                    v-if="
                                    recurringDate.recurring_period == 'monthly' ||
                                    recurringDate.recurring_period == 'specified_month'
                                    "
                                >
                                    <b-form-group>
                                    <b-form-select
                                        v-model="recurringDate.month_date"
                                        :options="dateOptions"
                                    ></b-form-select>
                                    <has-error
                                        :form="form"
                                        :field="`recursion_quote.${idx}.month_date`"
                                    ></has-error>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </div>
              <span
                style="
                  float: right;
                  color: #4682b4;
                  cursor: pointer;
                  font-size: 12px;
                "
                @click="addNewRecurringDate()"
                >Add More</span
              >
            </b-form-group>


            <b-form-group
              v-show="workOrder && componentForm.recurring == 'on'"
              label="Recurring End Date"
              v-slot="{ ariaDescribedby }"
            >
              <date-picker
                valueType="format"
                :format="'YYYY-MM-DD'"
                v-model="componentForm.recurring_end_date"
                :hide-header="true"
                :aria-describedby="ariaDescribedby"
                :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                placeholder="End Date"
                v-bind:class="{
                  'is-invalid': form.errors.has('recurring_end_date'),
                }"
              ></date-picker>
              <has-error :form="form" field="recurring_end_date"></has-error>
            </b-form-group>


                            <b-row class="mt-5">
                                <b-col v-if="!workOrder" cols="12">
                                    <b-form-group>
                                    <template v-slot:label>
                                        Quote Due By <span class="text-danger">*</span>
                                    </template>
                                        <date-picker
                                            valueType="format"
                                            :format="'YYYY-MM-DD'"
                                            v-model="componentForm.due_date"
                                            :hide-header="true"
                                            :aria-describedby="ariaDescribedby"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            placeholder="Due Date"
                                            v-bind:class="{
                                                'is-invalid': form.errors.has('due_date')
                                            }"
                                        ></date-picker>
                                            <has-error
                                                :form="form"
                                                field="due_date"
                                            ></has-error>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group
                                        v-if="!workOrder"
                                        label="Priority"
                                        v-slot="{ ariaDescribedby }"
                                    >

                                        <b-form-select
                                            v-if="workOrder"
                                            v-model="componentForm.priority"
                                            :aria-describedby="ariaDescribedby"
                                            :options="[
                                        { value: 'high', text: 'High (1-5 Days)' },
                                        { value: 'low', text: 'Low (Month)' }
                                    ]"
                                        ></b-form-select>
                                        <b-form-select
                                            v-else
                                            v-model="componentForm.priority"
                                            :aria-describedby="ariaDescribedby"
                                            :options="[
                                        { value: 'high', text: 'High (1-5 Days)' },
                                        { value: 'medium', text: 'Medium (1-2 Weeks)' },
                                        { value: 'low', text: 'Low (Month)' }
                                    ]"
                                        ></b-form-select>
                                        <has-error
                                            :form="form"
                                            field="priority"
                                        ></has-error>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-group
                                        :label="workOrder ? 'Work Order Completion By' : 'Project Completion By'"
                                        v-slot="{ ariaDescribedby }"
                                    >
                                        <date-picker
                                            valueType="format"
                                            :format="'YYYY-MM-DD'"
                                            v-model="componentForm.completion_date"
                                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                                            :aria-describedby="ariaDescribedby"
                                            placeholder="Completion Date"
                                            v-bind:class="{
                                                'is-invalid': form.errors.has(
                                                    'completion_date'
                                                )
                                            }"
                                        ></date-picker>
                                        <has-error
                                                :form="form"
                                                field="completion_date"
                                            ></has-error>
                                    </b-form-group>
                                </b-col>
                            </b-row>


                            <b-form-group
                                label="Budget Estimate (ex. GST)"
                                v-slot="{ ariaDescribedby }"
                            >
                                <b-row :aria-describedby="ariaDescribedby" class="mb-2 amount">
                                    <b-col v-if="!workOrder" cols="12" md="6">
                                        <b-input-group size="md" prepend="$" >
                                            <b-form-input
                                                type="text"
                                                v-model="componentForm.formattedMinEstimateBudget"
                                                placeholder="Min. Amount"
                                                v-bind:class="{
                                                    'is-invalid': form.errors.has(
                                                        'min_estimate_budget'
                                                    )
                                                }"
                                                @keyup="minEstimateBudgetFormat"
                                            ></b-form-input>
                                        </b-input-group>
                                        <has-error
                                            :form="form"
                                            field="min_estimate_budget"
                                        ></has-error>
                                    </b-col>

                                    <b-col cols="12" md="6">
                                        <b-input-group size="md" prepend="$" >
                                                <b-form-input
                                                    type="text"
                                                    v-model="componentForm.formattedMaxEstimateBudget"
                                                    placeholder="Max. Amount"
                                                    v-bind:class="{
                                                        'is-invalid': form.errors.has(
                                                            'max_estimate_budget'
                                                        )
                                                    }"
                                                @keyup="maxEstimateBudgetFormat"
                                                ></b-form-input>
                                            </b-input-group>
                                        <has-error
                                            :form="form"
                                            field="max_estimate_budget"
                                        ></has-error>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                                <b-form-group
                                        v-if="workOrder"
                                        label="High Priority"
                                        v-slot="{ ariaDescribedby }">
                                    <b-form-checkbox
                                        class="toggler"
                                        switch
                                        size="lg"
                                        type="text"
                                        v-model="componentForm.priority"
                                        value="high"
                                        unchecked-value="low"
                                        :aria-describedby="ariaDescribedby"
                                        v-bind:class="{
                                            'is-invalid': form.errors.has('priority')
                                        }"
                                    >
                                    </b-form-checkbox>
                                    <has-error
                                        :form="form"
                                        field="is_private"
                                    ></has-error>
                                </b-form-group>

                        <div class="btn-actions">
                            <b-button
                                class="back-btn"
                                :disabled="form.busy"
                                type="button"
                                variant="outline-primary"
                                 @click="
                                    workOrder
                                    ? $router.push({
                                        name: 'manager-workorder-edit',
                                        params: { id: form.id, step: 1 },
                                    })
                                    : $router.push({
                                        name: 'manager-quote-edit',
                                        params: { id: form.id, step: 1 },
                                    })"
                            >Back
                            </b-button>


                            <b-button
                                :disabled="form.busy"
                                type="submit"
                                variant="primary"
                                class="btn-grad btn-next"
                                >Next
                            </b-button>
                        </div>

                        </b-form>
                    </div>
                </div>
            </div>
        <!-- form ends -->
    </div>
    <!-- my code ends -->

</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { HasError } from "vform";
import _ from "lodash";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: ["form", "step", "sidebarListLinks", "eventParentToChildComponentFrom", "workOrder"],
    components: {
        NavBar,
        DatePicker,
        FooterComponent,
        SideBar,
        HasError,
        SvgIcons
    },
    data() {
        return {
            componentForm: {
                type: this.workOrder ? this.workOrder : 'quote',
                issue_date: "",
                due_date: "",
                completion_date: "",
                priority: "medium",
                min_estimate_budget: "",
                max_estimate_budget: "",
                formattedMinEstimateBudget: "",
                formattedMaxEstimateBudget: "",
                recurring: "off",
                recursion_quote: [
                    {
                        id: null,
                        day: null,
                        month: null,
                        month_date: null,
                        recurring_period: "daily",
                    },
                ],
                recurring_end_date: "",
            },
            recurringOptions: [
                { value: "daily", text: "Daily" },
                { value: "weekly", text: "Weekly" },
                { value: "monthly", text: "Monthly" },
                { value: "specified_month", text: "Specified Month" },
            ],
            dayOptions: [
                { value: null, text: "Choose a day" },
                { value: "sunday", text: "Sunday" },
                { value: "monday", text: "Monday" },
                { value: "tuesday", text: "Tuesday" },
                { value: "wednesday", text: "Wednesday" },
                { value: "thrusday", text: "Thrusday" },
                { value: "friday", text: "Friday" },
                { value: "saturday", text: "Saturday" },
            ],
            monthOptions: [
                { value: null, text: "Choose a month" },
                { value: "january", text: "January" },
                { value: "february", text: "February" },
                { value: "march", text: "March" },
                { value: "april", text: "April" },
                { value: "may", text: "May" },
                { value: "june", text: "June" },
                { value: "july", text: "July" },
                { value: "august", text: "August" },
                { value: "september", text: "September" },
                { value: "october", text: "October" },
                { value: "november", text: "November" },
                { value: "december", text: "December" },
            ],
            dateOptions: [{ value: null, text: "Choose a date" }],
            //  time1: null,
            //  time2: null,
            //  time3: null,

        };
    },
    mounted() {
        _.forEach(this.form, (value, field) => {
            if (field in this.componentForm) {
                this.componentForm[field] = value;
            }
        });

        //For Month Option
        for (var i = 1; i <= 31; i++) {
        this.dateOptions.push({
            value: i,
            text: i,
        });
        }

        //For Formating issue date
        //done in index.vue
        this.componentForm.issue_date = moment().format('YYYY-MM-DD');

        if(!this.componentForm.completion_date){
            this.componentForm.completion_date = moment().add(this.getPriorityDays(), 'days').format('YYYY-MM-DD');
        }

        //Called by parent from index page
        this.eventParentToChildComponentFrom.$on('event-parent-child-componentform', this.eventFromParentToChildComponentForm);
    },
    watch: {
        "componentForm.priority": {
            handler(newVal, oldVal) {
                this.componentForm.completion_date = moment().add(this.getPriorityDays(), 'days').format('YYYY-MM-DD');
            }
        }
    },
    methods: {
        getPriorityDays(){
            console.log("componentForm",this.componentForm);
            return this.componentForm.priority === 'high' ? 5 : (this.componentForm.priority === 'medium' ? 14 : 30);
        },
        componentFormSubmitted() {
            this.$emit("componentFormSubmitted", this.componentForm, 2, 1);
        },
        eventFromParentToChildComponentForm(value){
            _.forEach(value.data, (value, field) => {
                if (field in this.componentForm) {
                    this.componentForm[field] = value;
                }
            });
            if(!this.componentForm.completion_date){
                this.componentForm.completion_date = moment().add(this.getPriorityDays(), 'days').format('YYYY-MM-DD');
            }
        },
       minEstimateBudgetFormat(){
            this.componentForm.min_estimate_budget = this.componentForm.formattedMinEstimateBudget.replace(/\D/g, '');
            this.componentForm.formattedMinEstimateBudget = this.componentForm.formattedMinEstimateBudget.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        },
        maxEstimateBudgetFormat(){
            this.componentForm.max_estimate_budget = this.componentForm.formattedMaxEstimateBudget.replace(/\D/g, '');
            this.componentForm.formattedMaxEstimateBudget = this.componentForm.formattedMaxEstimateBudget.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        addNewRecurringDate() {
            this.componentForm.recursion_quote.push({
                id: null,
                day: null,
                month: null,
                month_date: null,
                recurring_period: "daily",
            });
        },
    },
};
</script>


<style scoped>
@media screen and (max-width: 575px) {
    .amount {
        gap: 10px;
    }
}
</style>
